import React from 'react';
import { popularSearches } from 'constants/popular-search.const';
import { TickCircle } from 'iconsax-react';

import classes from './ExplorePopularSearchWrapper.module.scss';

const ExplorePopularSearchWrapper = ({ searchKeyword, handleKeyWordChange }) => {
    return (
        <div className={`${classes.wrapper} d-flex flex-column gap-3`}>
            {popularSearches.map((keyWord) => (
                <div className={`${searchKeyword === keyWord.value ? `${classes['search-item']} ${classes['selected']}` : classes['search-item']}`} onClick={() => { handleKeyWordChange(keyWord.value) }}>
                    <TickCircle size={18} />
                    {keyWord.label}
                </div>
            ))}
        </div>
    );
};

export default ExplorePopularSearchWrapper;